import React from 'react';
import SVG from "react-inlinesvg";
import {Modal} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";
import {NavLink} from 'react-router-dom';
import {diffCheck, formatAmount} from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';
import {useGetOrderQuery} from "../../../../../../../redux/apiSlice";


const UpdateOrder = ({show, action: {action, error, data}, onHide}) => {
    const {isFetching, data: order} = useGetOrderQuery(data?.orderId)

    return <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
    >
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                    />
                </span> {action}
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
        </Modal.Header>
        <Modal.Body>
            <ErrorMessage {...{error}} />
            {isFetching && <div className="text-center py-10">
                <div className={`spinner-border mx-auto text-primary ${!isFetching ? "d-none" : ""}`}
                     style={{width: "4rem", height: "4rem", borderWidth: "0.1rem"}} role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>}
            {!isFetching && <div className="px-md-5">
                <div className="row">
                    <div className="col-md-4 h6">
                        User
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink to={`/users/view/${order?.userId}`} target="_blank">
                            {data?.username ?? ""}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Account Id
                    </div>
                    <div className="col-md h6 text-muted">
                        <NavLink
                            to={`/users/view/${order?.data?.meta?.userId}/account-information/${order?.data?.accountId}`}
                            className="text-muted text-hover-primary" target="_blank">
                            {order?.data?.accountId}
                        </NavLink>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Provider
                    </div>
                    <div className="col-md h6 text-muted">
                        {order?.data?.provider?.toUpperCase()}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Instrument
                    </div>
                    <div className="col-md h6 text-muted">
                        ({order?.data?.symbol}) {order?.data?.name}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Exchange
                    </div>
                    <div className="col-md h6 text-muted">
                        {order?.data?.exchange}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Side
                    </div>
                    <div className="col-md h6 text-muted">
                        {order?.data?.side}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Type
                    </div>
                    <div className="col-md h6 text-muted">
                        {order?.data?.type}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Status
                    </div>
                    <div className="col-md h6 text-muted">
                        {diffCheck(data.meta.status, data?.status)}
                    </div>
                </div>
                <div className={`row mt-4 ${order?.data.amount ? "" : "d-none"}`}>
                    <div className="col-md-4 h6">
                        Amount
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(order?.data?.currency, order?.data?.amount)}
                    </div>
                </div>
                <div className={`row mt-4 ${order?.data?.price ? "" : "d-none"}`}>
                    <div className="col-md-4 h6">
                        Price
                    </div>
                    <div className="col-md h6 text-muted">
                        {formatAmount(order?.data?.currency, order?.data?.price)}
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-4 h6">
                        Quantity
                    </div>
                    <div className="col-md h6 text-muted">
                        {order?.data?.quantity?.toLocaleString(undefined, {maximumFractionDigits: 10})}
                    </div>
                </div>
            </div>}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
    </Modal>
}

export default UpdateOrder;